import { useEffect } from 'react'

import { SCROLL_INTO_VIEW_TO_TOP } from '../../../../../../../constants/common'
import { useWidgetContext } from '../../../../../../Widget'
import { useListingProfileContext } from '../../../RentalPortalListingProfile.hooks'

export function useListingProfileBlockToEdit({ blockId, containerRef }) {
  const { blockToEdit, listingData, setBlockToEdit } =
    useListingProfileContext()

  const { handleEnableEditMode, handleToggleExpanded, isExpanded } =
    useWidgetContext()

  useEffect(() => {
    if (blockToEdit === blockId) {
      setBlockToEdit(null)

      if (listingData?.permissions?.can_edit) {
        if (!isExpanded) {
          handleToggleExpanded()
        }

        handleEnableEditMode()

        containerRef.current?.scrollIntoView(SCROLL_INTO_VIEW_TO_TOP)
      }
    }
  }, [blockToEdit])
}
